"use client";

import { c as _c } from "react/compiler-runtime";
import { SukhaBugLogoImage } from "@/components/shared/SukhaBugLogoImage";
import { cn } from "@/lib/utils";
interface SimpleToastProps {
  message: string | React.ReactNode;
  className?: string;
}
export function SimpleToast(t0) {
  const $ = _c(10);
  const {
    message,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex items-center gap-3", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SukhaBugLogoImage alt="Sukha" className="h-8 w-auto shrink-0" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== message) {
    t3 = typeof message === "string" ? <div>{message}</div> : message;
    $[3] = message;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="flex-1 min-w-0 text-white">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}